module.exports = __webpack_public_path__ + "static/img/img11.83ae23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regist/img11.png
// module id = ti3n
// module chunks = 1